import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TransactionsApi } from '../../apis';
import { UpdateTransaction } from '../../models/transactions';
import { QueryKeys } from '../query-keys';

const useUpdateTransaction = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (transaction: UpdateTransaction) =>
      TransactionsApi.update(transaction),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.TRANSACTIONS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.ACCOUNTS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CASHFLOWS] });
      queryClient.invalidateQueries({ queryKey: [QueryKeys.BALANCE_HISTORY] });
    },
  });

  return {
    updateTransaction: mutation.mutateAsync,
    isUpdating: mutation.isPending,
    wasUpdatedWithSuccess: mutation.isSuccess,
    wasUpdatedWithoutSuccess: mutation.isError,
  };
};

export default useUpdateTransaction;
